import React from 'react';
import ReactDOM from 'react-dom';
import CalendarDate from './components/CalendarDate';
import { renderEdit } from './form';

export const index = ctx => {
  renderDate();

  const id = ctx.params.id;
  if (id && !Number.isNaN(parseInt(id, 10))) {
    // Bind form handling
    renderEdit(id);
  }
};

function renderDate() {
  const root = document.getElementById('CalendarDate');
  if (root != null) {
    ReactDOM.render(<CalendarDate data={root.dataset} />, root);
  }
}



// WEBPACK FOOTER //
// ./src/modules/calendar/index.js